const WithoutResults = Vue.component('WithoutResults', {
  props: {
    title: String
  },
  template: `<div class="d-flex space-between">
    <span>{{ title }}</span>
    <img src="images/analytics-lupa.svg" class="mr-3" width="220px" :alt="title" />
  </div>`
});
